import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  TextField,
  IconButton,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ControlledTable from "../../../component/ControlledTable";
import { useDispatch, useSelector } from "react-redux";
import { salesListTable as tableDef } from "../../../config/grid-columns-defs";
import { handleAxiosError } from "../../../config/action-config";
import { Controller, useForm } from "react-hook-form";
import { showAlert } from "../../../actions/alert";
import { useNavigate } from "react-router-dom";
import { makeStyles } from "@material-ui/core";
import {
  createCommission,
  getCompanyList,
  getPartners,
} from "../../../api/commissions";
import {
  getIndustryList,
  getSalesCompanyList,
  getSalesList,
  getStageList,
} from "../../../api/sales";
import { getPartnersDropdownList } from "../../../api/partnerList";
const useStyles = makeStyles((theme) => ({
  textfeild: {
    "& .MuiFilledInput-root": {
      color: "#fff !important",
    },
  },
}));
export default function SalesList() {
  const classes = useStyles();
  let obj = tableDef.find((o) => o.headerName === "Action");
  const user = useSelector((state) => state.user);
  const dialogAction = useSelector((state) => state.dialog);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [totalCount, setTotalCount] = useState(0);
  const [rows, setRows] = useState([]);
  const [pageNumber, setPageNumber] = useState(0);
  const [partnerName, setPartnerName] = useState("");
  const [company, setCompany] = useState("");
  const [industry, setIndustry] = useState("");
  const [companyListData, setCompanyListData] = useState([]);
  const [industryListData, setIndustryListData] = useState([]);

  addAdditionalColumn(obj, dispatch);
  useEffect(() => {
    if (!dialogAction.type) return;
    switch (dialogAction.type) {
      case "VIEW":
        dispatch({ type: "" });
        navigate(`${dialogAction.data.lead_id}`);
        break;
      default:
        break;
    }
  }, [dialogAction]);

  useEffect(() => {
    refreshTable();
  }, [company, industry, partnerName]);
  const getRows = async (numRows, startRow) => {
    return getSalesList(
      {
        partnername: "",
        companyname: "",
        industry: "",
        stage: "Opportunity Won",
        limit: numRows,
        offset: startRow,
      },
      user.token
    )
      .then((res) => {
        setTotalCount(parseInt(res.data.total) === 0 ? -1 : res.data.total);
        return res.data.records;
      })
      .catch((err) => {
        handleAxiosError(err, dispatch);
        return [];
      });
  };
  const refreshTable = async () => {
    try {
      const { data } = await getSalesList(
        {
          partnername: partnerName,
          companyname: company,
          industry: industry,
          stage: "Opportunity Won",
          limit: 10,
          offset: 0,
        },
        user.token
      );
      setTotalCount(parseInt(data.total) === 0 ? -1 : parseInt(data.total));
      setRows(data.records);
    } catch (err) {
      handleAxiosError(err, dispatch);
    }
  };
  useEffect(() => {
    industryList();
    stageList();
  }, []);
  async function industryList() {
    try {
      const { data } = await getIndustryList(user.token);
      setIndustryListData(data.records);
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  }

  async function stageList() {
    try {
      const { data } = await getSalesCompanyList(user.token);
      setCompanyListData(data.records);
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  }

  return (
    <Box className="pmt-container-box">
      <Box className="pmt-title-box">
        <Box className="typography-title">
          <Typography variant="h1" className="pmt-headings-h1">Sales</Typography>
        </Box>
      </Box>
      <br />

      <Box className="pmt-filter-box">
        <Grid
          container
          className="report-filter-box"
          rowSpacing={1}
          columnSpacing={{ xs: 1, sm: 1, md: 1 }}
        >
          <Grid item lg={2} md={3} sm={4} xs={12}>
            <TextField
              className={classes.textfeild}
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={partnerName}
              fullWidth
              label="Partner Name"
              size="small"
              onChange={(e) => {
                setPartnerName(e.target.value);
              }}
            />
          </Grid>
          <Grid item lg={2} md={3} sm={4} xs={12}>
            <FormControl fullWidth size="small">
              <InputLabel id="demo-simple-select-label" size="small">
                Company Name
              </InputLabel>
              <Select
                MenuProps={{ className: "select-box-height" }}
                className={classes.textfeild}
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={company}
                label="Company Name"
                size="small"
                sx={{ background: "#fff" }}
                onChange={(e) => {
                  setCompany(e.target.value);
                }}
              >
                <MenuItem value="">Select</MenuItem>
                {companyListData.map((c, i) => (
                  <MenuItem key={i} value={c.company_name}>
                    {c.company_name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item lg={2} md={3} sm={4} xs={12}>
            <FormControl fullWidth size="small">
              <InputLabel id="demo-simple-select-label" size="small">
                Industry
              </InputLabel>
              <Select
                MenuProps={{ className: "select-box-height" }}
                sx={{ background: "#fff" }}
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                size="small"
                value={industry}
                label="Industry"

                onChange={(e) => {
                  setIndustry(e.target.value);
                }}
              >
                <MenuItem value="">Select</MenuItem>
                {industryListData.map((c, i) => (
                  <MenuItem key={i} value={c.industry_display_value}>
                    {c.industry_display_value}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </Box>
      <br />
      <div className="pmt-controll-table">
        <ControlledTable
          rows={rows}
          columnDefs={tableDef}
          getRows={getRows}
          totalCount={totalCount}
          onChange={setRows}
          onPageNumberChange={setPageNumber}
          pageSize={10}
          pageNumber={pageNumber}
          pagination={true}
          hasActionButtons={false}
        />
      </div>
      {/* <AddNewLeadDialog
        open={createDialogOpen}
        setOpen={setCreateDialogOpen}
        onRefresh={refreshTable}
      /> */}
    </Box>
  );
}

function addAdditionalColumn(obj, dispatch) {
  if (obj === undefined) {
    tableDef.unshift({
      headerName: "Action",
      field: "actions",
      minWidth:70,
      resizable: true,
      headerClass: "justify-center",
      cellClass: "justify-center",

      cellRendererFramework: (params) => (
        <IconButton
          color="info"
          onClick={() => {
            dispatch({ type: "VIEW", data: params.data });
          }}
        >
          <VisibilityIcon fontSize="inherit" />
        </IconButton>
      ),
    });
  }
}
const emptyNewCommissionData = {
  partner_id: "",
  lead_id: "",
  cloud_sales: "",
  services_sales: "",
  status: "",
  deal_value_closed: "",
};
function AddNewLeadDialog({ open, setOpen, onRefresh }) {
  const user = useSelector((state) => state.user);
  const [data, setData] = useState(emptyNewCommissionData);
  const [partnerListData, setPartnerListData] = useState([]);
  const [companyListData, setCompanyListData] = useState([]);
  const {
    register,
    handleSubmit,
    reset,
    control,
    formState: { errors },
  } = useForm({ defaultValues: emptyNewCommissionData });

  const dispatch = useDispatch();
  useEffect(() => {
    if (open) {
      setData(emptyNewCommissionData);
    }
  }, [open]);

  async function onNewCommissionSubmit(newdata) {
    try {
      const { data } = await createCommission(newdata, user.token);
      dispatch(showAlert(data.msg));
      setOpen(false);
      onRefresh();
    } catch (err) {
      handleAxiosError(err, dispatch);
      setOpen(false);
    }
  }
  async function partnerList() {
    const token = user.token;
    try {
      const { data } = await getPartners(token);
      setPartnerListData(data.data);
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  }
  async function companyList() {
    const token = user.token;
    try {
      const { data } = await getCompanyList(token);
      setCompanyListData(data.records);
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  }

  useEffect(() => {
    partnerList();
    companyList();
  }, []);

  return (
    <Dialog
      open={open}
      onClose={() => {
        // setOpen(true);
      }}
    >
      <DialogTitle>Create New Commission</DialogTitle>
      <Box component="form" onSubmit={onNewCommissionSubmit}>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={6}>
              <FormControl fullWidth required error={Boolean(errors.partner_id)}>
                <InputLabel id="demo-simple-select-label-a">
                  Partner Name
                </InputLabel>
                <Controller
                  render={(props) => (
                    <Select MenuProps={{ className: "select-box-height" }} value={props.value} onChange={props.onChange}>
                      {partnerListData.map((p, i) => (
                        <MenuItem key={i} value={p.id}>
                          {p.firstname}
                        </MenuItem>
                      ))}
                    </Select>
                  )}
                  name="partner_id"
                  control={control}
                  rules={{
                    required: "Please select Partner Name",
                  }}
                />
                <FormHelperText>{errors.partner_id?.message}</FormHelperText>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6} md={6}>
              <FormControl fullWidth required error={Boolean(errors.lead_id)}>
                <InputLabel id="demo-simple-select-label-a">
                  Company Name
                </InputLabel>
                <Controller
                  render={(props) => (
                    <Select MenuProps={{ className: "select-box-height" }} value={props.value} onChange={props.onChange}>
                      {companyListData.map((c, i) => (
                        <MenuItem key={i} value={c.lead_id}>
                          {c.company_name}
                        </MenuItem>
                      ))}
                    </Select>
                  )}
                  name="lead_id"
                  control={control}
                  rules={{
                    required: "Please select Company Name",
                  }}
                />
                <FormHelperText>{errors.lead_id?.message}</FormHelperText>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <TextField
                name="deal_value_closed"
                label="Deal Value Closed"
                required
                fullWidth
                inputRef={register({
                  required: "Deal Value Closed is required.",
                })}
                error={Boolean(errors.deal_value_closed)}
                helperText={errors.deal_value_closed?.message}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <TextField
                name="cloud_sales"
                label="Cloud Sales"
                required
                fullWidth
                inputRef={register({
                  required: "Cloud Sales is required.",
                })}
                
                error={Boolean(errors.cloud_sales)}
                helperText={errors.cloud_sales?.message}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <TextField
                name="services_sales"
                label="Services Sales"
                required
                fullWidth
                inputRef={register({
                  required: "Services Sales is required.",
                })}
                
                error={Boolean(errors.contact)}
                helperText={errors.contact?.message}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpen(false);
            }}
            className="cancel-button"
          >
            Cancel
          </Button>
          <Button onClick={handleSubmit(onNewCommissionSubmit)} type="submit" className="blue-button">
            Submit
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
}
